// extracted by mini-css-extract-plugin
module.exports = {"time":"Timer_time___rTf5","separator":"Timer_separator__3Yj-1","timepart":"Timer_timepart__1csBs"};